module.exports = __webpack_public_path__ + "static/media/custom.a126aab4.png";